import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of, switchMap } from 'rxjs';
import { CoursesService } from '../services/courses.service';
import { ContentService } from '../services/content.service';

@Injectable({
  providedIn: 'root'
})

export class CourseGuard {

  courseId: string = '';

  constructor(private coursesService: CoursesService, private contentService:ContentService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const path = route.paramMap.get('course-name');

      return this.contentService.getIdByPath(path).pipe(
        switchMap(id => {
          return this.coursesService.getCourseById(id);
        }),
        map(course => {
          if (course && course.attributes.status === true) {
            return true;
          } else {
            this.router.navigate(['/cursos']);
            return false;
          }
        }),
        catchError(err => {
          console.error(err);
          this.router.navigate(['/cursos']);
          return of(false);
        })
      );


  }

}
